module.exports = __webpack_public_path__ + "img/1560519655.7ba484dc.jpg";